// Helper to initialize Firebase (if config provided) and return FCM token.
// Expects REACT_APP_FIREBASE_CONFIG to be a JSON string containing the firebase config object.

export async function getFcmToken() {
  try {
    if (typeof window === 'undefined') return null;

    const raw = process.env.REACT_APP_FIREBASE_CONFIG || null;
    if (!raw) {
      console.warn('getFcmToken: no REACT_APP_FIREBASE_CONFIG provided');
      return null;
    }

    let firebaseConfig;
    try {
      firebaseConfig = JSON.parse(raw);
    } catch (e) {
      console.error('getFcmToken: failed to parse REACT_APP_FIREBASE_CONFIG', e);
      return null;
    }

    // Dynamic import so build doesn't fail if firebase isn't installed yet
    const { initializeApp, getApps } = await import('firebase/app');
    const { getMessaging, getToken, isSupported } = await import('firebase/messaging');

    // Initialize app (if not already)
    if (getApps().length === 0) {
      initializeApp(firebaseConfig);
    }

    const supported = await isSupported();
    if (!supported) {
      console.warn('getFcmToken: firebase messaging not supported in this browser');
      return null;
    }

    const messaging = getMessaging();

    try {
      // Request permission is not needed for modern browsers if using service worker, but keep a friendly call
      const currentToken = await getToken(messaging, {
        vapidKey: firebaseConfig.vapidKey || undefined,
      });
      return currentToken || null;
    } catch (err) {
      console.warn('getFcmToken: unable to get token', err);
      return null;
    }
  } catch (err) {
    console.warn('getFcmToken: firebase not available or failed to initialize', err);
    return null;
  }
}
